import { faHeart, far, faUser } from "@fortawesome/free-regular-svg-icons";
import {
  faL,
  fas,
  faShoppingBag,
  faShoppingCart,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Skeleton } from "antd";
import { medusaRequester, storeRequester } from "App";
import clsx from "clsx";
import DesktopLanguageSwitcher from "components/countryFlag/DesktopLanguageSwitcher";
import Dummy from "components/Dummy";
import P from "components/P";
import SkeletonImage from "components/skeleton/SkeletonImage";
import SkeletonText from "components/skeleton/SkeletonText";
import Container from "layouts/container/Container";
import FlexChild from "layouts/flex/FlexChild";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import VerticalFlex from "layouts/flex/VerticalFlex";
import Center from "layouts/wrapper/Center";
import SquareWrapper from "layouts/wrapper/SquareWrapper";
import { debounce } from "lodash";
import { AuthContext } from "providers/AuthProvider";
import { BrowserDetectContext } from "providers/BrowserEventProvider";
import { useContext, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, NavLink, useNavigate } from "react-router-dom";
import background from "resources/img/header/background.png";
import findByCategory from "resources/img/icons/category.svg";
import findByAll from "resources/img/icons/findByAll.png";
import findByBrand from "resources/img/icons/findByBrand.png";
import WorldvapeLogo from "resources/img/logo/worldvape_logo.svg";
import TopBarItem from "routes/main/top/TopBarItem";
import TopBarSubItem from "routes/main/top/TopBarSubItem";
import { getCurrentLanguageCode, removeLocalStorage } from "shared/utils/Utils";
import Cart from "./CartButton";
import style from "./DesktopHeader.module.css";
import SearchBar from "./SearchBar";
import NiceModal from "@ebay/nice-modal-react";
import CustomIcon from "components/icons/CustomIcon";
import MenuBar from "../menuBar/MenuBar";
import SearchTopBarItem from "routes/main/top/SearchTopBarItem";
import { CartReducer } from "shared/redux/reducers/shopping/CartReducer";
import { OrderInfoReducer } from "shared/redux/reducers/shopping/OrderInfoReducer";
import { WishReducer } from "shared/redux/reducers/shopping/WishReducer";
import { DirectPurchaseReducer } from "shared/redux/reducers/shopping/DirectPurchaseReducer";
import { SearchConditionReducer } from "shared/redux/reducers/product/SearchConditionReducer";
import { HistoryReducer } from "shared/redux/reducers/history/HistoryReducer";
import { VendorReducer } from "shared/redux/reducers/vendor/VendorReducer";
import { PointReducer } from "shared/redux/reducers/shopping/PointReducer";
import { useDispatch, useSelector } from "react-redux";
import { AuthReducer } from "shared/redux/reducers/auth/AuthReducer";
import { Cookie, deleteCookie } from "shared/StoreRequester";
import { RegionContext } from "providers/RegionProvider";
import { SearchReducer } from "shared/redux/reducers/search/SearchReducer";


function DesktopHeader(props) {
  const [mounted, setMounted] = useState(false);
  const { userName } = useContext(AuthContext);
  const { regionId } = useContext(RegionContext);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [currentCustomer, setCurrentCustomer] = useState();
  const [wishAmount, setWishAmount] = useState(0);
  const [cartAmount, setCartAmount] = useState(0);
  const [selectedMenu, setSelectedMenu] = useState(null);
  const { headerVisible } = useSelector((state) => state.search);



  const [isVisible, setIsVisible] = useState(true);
  const lastScrollY = useRef(window.scrollY);
  const headerHeight = 81; // 스크롤 감지 높이
  const ticking = useRef(false);

  const menus = [
    {
      key: "notice",
      label: t("notice"),
      click: () => onArticleClick(),
    },
    {
      key: userName ? "signOut" : "signIn",
      label: userName ? t("signOut") : t("signIn"),
      click: () => onLoginClick(userName ? "signOut" : "signIn"),
    },
    !userName && {
      key: "signUp",
      label: t("signUp"),
      click: () => onSignUpClick(),
    },
    // {
    //   key: "orderInfo",
    //   label: t("orderInfo"),
    //   click: () => onTrackOrderClick(),
    // },
  ].filter(Boolean);
  useEffect(() => setMounted(true), [mounted]);
  useEffect(() => {
    if (userName) {
      storeRequester.getCurrentCustomer({}, ({ customer }) =>
        setCurrentCustomer(customer)
      );
    } else {
      setCurrentCustomer(null);
    }
  }, [userName]);
  const onArticleClick = () => {
    navigate("/article/notice");
  };

  const onTrackOrderClick = () => {
    navigate("/mypage");
  };

  const onLoginClick = (key) => {
    if (key === "signIn") {
      NiceModal.show("memberSignIn");
      setSelectedMenu(key);
    } else {
      onLogoutClick();
    }
  };

  const onLogoutClick = () => {
    NiceModal.show("confirm", {
      message: t("confirmLogout"),
      confirmText: t("confirm"),
      cancelText: t("cancel"),
      onConfirm: onConfirm,
      onCancel: onCancel,
    });
  };

  const onConfirm = () => {
    removeLocalStorage("token");
    dispatch(CartReducer.actions.reset());
    dispatch(OrderInfoReducer.actions.reset());
    dispatch(WishReducer.actions.reset());
    dispatch(DirectPurchaseReducer.actions.reset());
    dispatch(SearchConditionReducer.actions.reset());
    dispatch(HistoryReducer.actions.reset());
    dispatch(VendorReducer.actions.reset());
    dispatch(PointReducer.actions.reset());
    navigate("/", { replace: true });
    storeRequester.Logout(() => {
      dispatch(AuthReducer.actions.reset());
      // to-do logout
      deleteCookie(Cookie.Cart);
    });
  };

  const onCancel = () => { };

  const onSignUpClick = () => {
    NiceModal.show("memberSignTabModal");
  };

  const getWishList = async () => {
    if (currentCustomer?.id) {
      medusaRequester
        .getMyWishProducts(currentCustomer.id, (result) =>
          setWishAmount(result.interests.length)
        )
        .catch((e) => {

        });
    }
  };

  const fetchMedusaCart = async () => {
    try {
      const { cart } = await storeRequester.getMyCart(regionId);
      setCartAmount(cart?.items?.length || 0);
      return cart;
    } catch (error) {

    }
  };

  // useEffect(() => {
  //   // 포커스 이벤트 모니터링을 추가해서 확인해볼 수 있습니다
  //   const handleFocus = (e) => {
  //     console.log('Focus event:', {
  //       target: e.target,
  //       scrollY: window.scrollY
  //     });
  //   };

  //   document.addEventListener('focus', handleFocus, true);
  //   return () => document.removeEventListener('focus', handleFocus, true);
  // }, []);

  // useEffect(() => {
  //   const logScroll = () => {
  //     console.log('Scroll Event Triggered', {
  //       scrollY: window.scrollY,
  //       timestamp: new Date().toISOString(),
  //       stack: new Error().stack // 호출 스택 추적
  //     });
  //   };

  //   window.addEventListener('scroll', logScroll);
  //   return () => window.removeEventListener('scroll', logScroll);
  // }, []);

  useEffect(() => {
    getWishList();
    fetchMedusaCart();
  }, []);

  useEffect(() => {
    // 초기 스크롤 위치 저장
    lastScrollY.current = window.scrollY;

    const updateHeader = () => {
      const currentScrollY = window.scrollY;

      // 스크롤 방향 체크 (이전 스크롤 위치와 현재 스크롤 위치 비교)
      const isScrollingDown = currentScrollY > lastScrollY.current;

      // 스크롤 위치가 헤더 높이보다 작으면 항상 표시
      if (currentScrollY < headerHeight) {
        dispatch(SearchReducer.actions.setHeaderVisible(true));
      } else {
        // 스크롤 방향에 따라 표시/숨김
        if (isScrollingDown) {
          dispatch(SearchReducer.actions.setHeaderVisible(false));
        } else {
          dispatch(SearchReducer.actions.setHeaderVisible(true));
        }
      }

      // 현재 스크롤 위치 저장
      lastScrollY.current = currentScrollY;
      ticking.current = false;
    };

    const onScroll = () => {
      if (!ticking.current) {
        // requestAnimationFrame을 사용하여 다음 프레임에서 처리
        requestAnimationFrame(() => {
          updateHeader();
        });
        ticking.current = true;
      }
    };

    window.addEventListener('scroll', onScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', onScroll);
    };
  }, [dispatch]);

  // useEffect(() => {
  //   let ticking = false;

  //   const updateHeader = () => {
  //     const currentScrollY = window.scrollY;
  //     const isScrollingDown = currentScrollY > lastScrollY.current;

  //     // 스크롤 위치가 헤더 높이보다 작으면 항상 표시
  //     if (currentScrollY < headerHeight) {
  //       setIsVisible(true);
  //     } else {
  //       // 스크롤 방향에 따라 표시/숨김
  //       if (isScrollingDown && currentScrollY > headerHeight) {
  //         setIsVisible(false);
  //       } else {
  //         setIsVisible(true);
  //       }
  //     }

  //     lastScrollY.current = currentScrollY;
  //     ticking = false;
  //   };

  //   const onScroll = () => {
  //     if (!ticking) {
  //       window.requestAnimationFrame(() => {
  //         updateHeader();
  //       });
  //       ticking = true;
  //     }
  //   };

  //   // 초기 스크롤 위치 저장
  //   lastScrollY.current = window.scrollY;

  //   window.addEventListener('scroll', onScroll, { passive: true });
  //   return () => window.removeEventListener('scroll', onScroll);
  // }, []);

  return (
    <div
      className={clsx(style.container, {
        [style.hidden]: !headerVisible
      })}
    >
      <VerticalFlex>
        <FlexChild>
          <div style={{ backgroundColor: "white" }}>
            <VerticalFlex>
              <FlexChild>
                <Container minWidth={1520}>
                  <HorizontalFlex
                    height={"40px"}
                    gap={"20px"}
                    padding={"0 20px 0 0"}
                  >
                    {menus.map((menu) => (
                      <FlexChild
                        key={menu.key}
                        justifyContent={
                          menu.key === "notice" ? "flex-end" : "flex-start"
                        }
                        width={menu.key === "notice" ? null : "max-content"}
                      >
                        <P cursor enableHover onClick={menu.click} weight={700}>
                          {menu.label}
                        </P>
                      </FlexChild>
                    ))}
                  </HorizontalFlex>
                </Container>
              </FlexChild>
              <FlexChild>
                <div
                  style={{
                    backgroundColor: "rgba(239, 239, 239, 1)",
                    height: "1.5px",
                  }}
                />
              </FlexChild>
            </VerticalFlex>
          </div>
        </FlexChild>
        <FlexChild>
          <div
            className={style.wrap}
            style={{ backgroundColor: "white", height: "80px" }}
          >
            {/* <div className={style.wrap} style={{ backgroundColor: "white", height: headerHeight }} > */}
            <div className={style.paddingWrap}>
              {/* <div className={clsx(style.paddingWrap, { [style.scroll]: scroll })}> */}
              <Container minWidth={1520}>
                <div style={{ position: "absolute", top: "10px" }}>
                  <Center>
                    {/* <div className={style.logo}> */}
                    <img
                      className={style.logo}
                      src={WorldvapeLogo}
                      onClick={() => {
                        navigate("/");
                      }}
                    />
                    

                    {/* </div> */}
                  </Center>
                </div>

                {/* <HorizontalFlex > */}
                {/* <FlexChild padding={10}> */}

                {/* </FlexChild> */}
                {/* <FlexChild>
                    <Center width={"100%"}>
                      <SearchBar />
                    </Center>
                  </FlexChild> */}
                <FlexChild justifyContent={"flex-end"}>
                  <Container height={40}>
                    <Container minWidth={1520}>
                      <ul className={style.columns}>
                        {/* <li className={style.column}>
                            <DesktopLanguageSwitcher />
                          </li> */}
                        <SearchTopBarItem
                          icon={faShoppingCart}
                          color={"black"}
                        />
                        {/* <TopBarItem
                          icon={faHeart}
                          color={"black"}
                          url={"/wishlist"}
                        /> */}
                        {/* <TopBarItem
                          icon={faShoppingCart}
                          // url={"/shopping/cart"}
                          url={"/shopping/orderSummary"}
                          color={"black"}
                          cartAmount={cartAmount}
                        /> */}
                        {/* <TopBarItem icon={faHeart} url={"/wishList"} color={"black"} wishAmount={wishAmount} /> */}
                        <TopBarItem
                          icon={faUser}
                          color={"black"}
                          url={"/mypage"}
                        />

                        {/* <TopBarSubItem title={t("orderHistory")} url={"/mypage"} />
                            <TopBarSubItem title={t("cart")} url={"/shopping/cart"} />
                            <TopBarSubItem title={t("wishList")} url={"/wishList"} />
                            {
                              !userName && <TopBarSubItem login title={t("signIn")} />
                            }
                          </TopBarItem> */}
                      </ul>
                    </Container>
                  </Container>
                </FlexChild>
                {/* </HorizontalFlex> */}
              </Container>
              <div
                style={{
                  width: "100%",
                  height: "1.5px",
                  backgroundColor: "rgba(201, 202, 202, 1)",
                }}
              />
              <MenuBar />
            </div>
          </div>
        </FlexChild>
        <FlexChild></FlexChild>
      </VerticalFlex>
    </div>
  );
}

export default DesktopHeader;
